document.addEventListener('DOMContentLoaded', function() {

  // Function to observe price list elements
  function observePriceList() {
    // Find all price-list elements on the page
    const priceLists = document.querySelectorAll('.price-list');
    
    if (priceLists.length === 0) {
      console.log('No price-list elements found on page');
      return;
    }
    
  // Create a mutation observer instance
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {      
      // If you want to extract the actual price values
      if (mutation.type === 'childList') {
        const newPrice = mutation.target.textContent.trim();
        // Pass the observed price to the update function
        updateApplicationPrice(newPrice);
      }
    });
  });
    
    // Configuration for the observer (observe everything)
    const config = { 
      attributes: true, 
      childList: true, 
      subtree: true,
      characterData: true 
    };
    
    // Start observing each price-list element
    priceLists.forEach((priceList, index) => {
      observer.observe(priceList, config);
    });
    
    // Update application-price with static value
    updateApplicationPrice();
  }
  
  // Function to update .application-price elements with static value
  function updateApplicationPrice(observedPrice = null) {
    const applicationPrices = document.querySelectorAll('.application-price');
    
    if (applicationPrices.length === 0) {
      console.log('No .application-price elements found');
      return;
    }
    
    // Only proceed if we have an observed price
    if (!observedPrice) {
      console.log('No observed price provided');
      return;
    }
    
    try {
      // Safely get quantity and application number with fallbacks
      const quantityElement = document.querySelector('.pmpr_input[name="quantity"]');
      const applicationElement = document.querySelector('.application-number');
      
      if (!quantityElement || !applicationElement) {
        console.log('Required elements not found');
        return;
      }
      
      // Parse input values with cleaner error handling
      const extractNumber = (value, isInteger = false) => {
        if (!value) return isInteger ? 1 : 0;
        
        if (typeof value === 'string') {
          // Clean and normalize the string
          const cleanValue = value.trim().replace(/[^0-9.,]/g, '').replace(',', '.');
          return isInteger ? parseInt(cleanValue, 10) || 1 : parseFloat(cleanValue) || 0;
        }
        
        return isInteger ? (parseInt(value, 10) || 1) : (parseFloat(value) || 0);
      };

      // Extract values using the helper function
      const quantity = extractNumber(quantityElement.value, true);
      const applicationNumber = extractNumber(applicationElement.textContent, true);
      const observedPriceNumber = extractNumber(observedPrice);

      // Calculate prices with a single calculation flow
      const unitPrice = (observedPriceNumber / quantity).toFixed(2);
      let priceValue = (unitPrice / applicationNumber).toFixed(2);
      
      // Format price for display (using German format with comma)
      priceValue = priceValue.replace('.', ',');
      
      // Update all price elements using a common function
      updatePriceElements(applicationPrices, priceValue);
    } catch (error) {
      console.error('Error updating application price:', error);
    }
  }

  // Helper function to update price elements
  function updatePriceElements(elements, newPrice) {
    elements.forEach((element, index) => {
      const priceSpan = element.querySelector('.price');
      const targetElement = priceSpan || element;
      const currentText = targetElement.textContent;
      
      // Replace numeric part while preserving surrounding text
      const updatedText = currentText.replace(/\d+(?:[.,]\d+)?/g, newPrice);
      targetElement.textContent = updatedText;
    });
  }
  
  // Run immediately
  observePriceList();
  
  
});

var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);

// node_modules/ftdomdelegate/main.js
function Delegate(root) {
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }
  this.handle = Delegate.prototype.handle.bind(this);
  this._removedListeners = [];
}
Delegate.prototype.root = function(root) {
  const listenerMap = this.listenerMap;
  let eventType;
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }
  this.rootElement = root;
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, true);
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, false);
    }
  }
  return this;
};
Delegate.prototype.captureForType = function(eventType) {
  return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType) !== -1;
};
Delegate.prototype.on = function(eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;
  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }
  if (useCapture === void 0) {
    useCapture = this.captureForType(eventType);
  }
  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }
  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, useCapture);
    }
    listenerMap[eventType] = [];
  }
  if (!selector) {
    matcherParam = null;
    matcher = matchesRoot.bind(this);
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }
  listenerMap[eventType].push({
    selector,
    handler,
    matcher,
    matcherParam
  });
  return this;
};
Delegate.prototype.off = function(eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }
  if (useCapture === void 0) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }
    return this;
  }
  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];
    if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }
  if (!listenerList.length) {
    delete listenerMap[eventType];
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }
  return this;
};
Delegate.prototype.handle = function(event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";
  if (event[eventIgnore] === true) {
    return;
  }
  target = event.target;
  if (target.nodeType === 3) {
    target = target.parentNode;
  }
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }
  root = this.rootElement;
  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
  switch (phase) {
    case 1:
      listenerList = this.listenerMap[1][type];
      break;
    case 2:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3:
      listenerList = this.listenerMap[0][type];
      break;
  }
  let toFire = [];
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];
      if (!listener) {
        break;
      }
      if (target.tagName && ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 && target.hasAttribute("disabled")) {
        toFire = [];
      } else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }
    if (target === root) {
      break;
    }
    l = listenerList.length;
    target = target.parentElement || target.parentNode;
    if (target instanceof HTMLDocument) {
      break;
    }
  }
  let ret;
  for (i = 0; i < toFire.length; i++) {
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }
  return ret;
};
Delegate.prototype.fire = function(event, target, listener) {
  return listener.handler.call(target, event, target);
};
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document || // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement || // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}
function matchesId(id, element) {
  return id === element.id;
}
Delegate.prototype.destroy = function() {
  this.off();
  this.root();
};
var main_default = Delegate;


var CustomHTMLElement = class extends HTMLElement {
  constructor() {
    super();
    this._hasSectionReloaded = false;
    if (Shopify.designMode) {
      this.rootDelegate.on("shopify:section:select", (event) => {
        const parentSection = this.closest(".shopify-section");
        if (event.target === parentSection && event.detail.load) {
          this._hasSectionReloaded = true;
        }
      });
    }
  }
  get rootDelegate() {
    return this._rootDelegate = this._rootDelegate || new main_default(document.documentElement);
  }
  get delegate() {
    return this._delegate = this._delegate || new main_default(this);
  }
  showLoadingBar() {
    triggerEvent(document.documentElement, "theme:loading:start");
  }
  hideLoadingBar() {
    triggerEvent(document.documentElement, "theme:loading:end");
  }
  untilVisible(intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }) {
    const onBecameVisible = () => {
      this.classList.add("became-visible");
      this.style.opacity = "1";
    };
    return new Promise((resolve) => {
      if (window.IntersectionObserver) {
        this.intersectionObserver = new IntersectionObserver((event) => {
          if (event[0].isIntersecting) {
            this.intersectionObserver.disconnect();
            requestAnimationFrame(() => {
              resolve();
              onBecameVisible();
            });
          }
        }, intersectionObserverOptions);
        this.intersectionObserver.observe(this);
      } else {
        resolve();
        onBecameVisible();
      }
    });
  }
  disconnectedCallback() {
    this.delegate.destroy();
    this.rootDelegate.destroy();
    this.intersectionObserver?.disconnect();
    delete this._delegate;
    delete this._rootDelegate;
  }
};



var CustomAnnouncementBar = class extends CustomHTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll("custom-announcement-bar-item"));
    this.slider = null;
    this.mediaQuery = window.matchMedia('(max-width: 999px)');
    this.autoplayTimer = null;
    
    if (this.items.length > 1) {
      // Setup slider initially if needed
      if (this.mediaQuery.matches) {
        this.classList.add("is-slider-initializing");
        this._setupKeenSlider();
        this._createNavigationButtons(); // Add navigation buttons
        this._setupNavigation();
        
        if (this.autoPlay) {
          this._setupAutoplay();
        }
      }

      // Listen for media query changes
      this.mediaQuery.addListener(this._onMediaQueryChange.bind(this));
      
      // Add listeners for content open/close events to restart autoplay
      this.addEventListener("announcement-bar:content:open", this._pauseAutoplay.bind(this));
      this.addEventListener("announcement-bar:content:close", this._restartAutoplay.bind(this));
    }
  }

  get autoPlay() {
    return this.hasAttribute("auto-play");
  }

  _onMediaQueryChange(event) {
    if (event.matches) {
      // Moving to mobile - initialize slider
      if (!this.slider) {
        this.classList.add("is-slider-initializing");
        this._setupKeenSlider();
        this._createNavigationButtons(); // Add navigation buttons when switching to mobile
        this._setupNavigation();
        
        if (this.autoPlay) {
          this._setupAutoplay();
        }
      }
    } else {
      // Moving to desktop - destroy slider
      if (this.slider) {
        this._clearAutoplayTimer();
        this.slider.destroy();
        this.slider = null;
        
        // Remove navigation buttons when switching to desktop
        this._removeNavigationButtons();
      }
    }
  }

  _createNavigationButtons() {
    // Check if navigation container already exists
    let navContainer = this.querySelector('.announcement-bar__nav');
    
    if (!navContainer) {
      // Create navigation container
      navContainer = document.createElement('div');
      navContainer.className = 'announcement-bar__nav';
      
      // Create previous button
      const prevButton = document.createElement('button');
      prevButton.className = 'announcement-bar__nav-button announcement-bar__nav-button--prev';
      prevButton.setAttribute('data-action', 'prev');
      prevButton.setAttribute('aria-label', 'Previous announcement');
      prevButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" class="nav-icon icon-chevron-right" viewBox="0 0 192 192" fill="none"><path d="M72 36L132 96L72 156" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      
      // Create next button
      const nextButton = document.createElement('button');
      nextButton.className = 'announcement-bar__nav-button announcement-bar__nav-button--next';
      nextButton.setAttribute('data-action', 'next');
      nextButton.setAttribute('aria-label', 'Next announcement');
      nextButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" class="nav-icon icon-chevron-right" viewBox="0 0 192 192" fill="none"><path d="M72 36L132 96L72 156" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      
      // Append buttons to container
      navContainer.appendChild(prevButton);
      navContainer.appendChild(nextButton);
      
      // Append container to announcement bar
      this.appendChild(navContainer);
    }
  }

  _removeNavigationButtons() {
    const navContainer = this.querySelector('.announcement-bar__nav');
    if (navContainer) {
      navContainer.remove();
    }
  }

  _setupKeenSlider() {
    this.slider = new KeenSlider(this.querySelector(".announcement-bar__list"), {
      loop: true,
      mode: "snap",
      rtl: window.themeVariables.settings.direction === "rtl",
      slides: {
        origin: "center",
        perView: 1,
        spacing: 0
      },
      centered: true,
      defaultAnimation: {
        duration: 400
      },
      created: () => {
        // Remove loading class when slider is fully initialized
        this.classList.remove("is-slider-initializing");
        this.classList.add("is-slider-initialized");
      }
    });
  }

  _setupNavigation() {
    const prevButton = this.querySelector('[data-action="prev"]');
    const nextButton = this.querySelector('[data-action="next"]');

    if (prevButton && this.slider) {
      prevButton.addEventListener("click", () => {
        this.slider.prev();
        // Restart autoplay after manual navigation
        this._restartAutoplay();
      });
    }

    if (nextButton && this.slider) {
      nextButton.addEventListener("click", () => {
        this.slider.next();
        // Restart autoplay after manual navigation
        this._restartAutoplay();
      });
    }
  }

  _setupAutoplay() {
    if (!this.slider) return;
    
    this._clearAutoplayTimer();
    
    const cycleSpeed = parseInt(this.getAttribute("cycle-speed")) * 1000;
    
    this.autoplayTimer = setInterval(() => {
      if (this.slider) {
        this.slider.next();
      }
    }, cycleSpeed);

    // Pause on hover
    this.addEventListener("mouseenter", this._pauseAutoplay.bind(this));
    this.addEventListener("mouseleave", this._restartAutoplay.bind(this));
  }
  
  _clearAutoplayTimer() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
  
  _pauseAutoplay() {
    this._clearAutoplayTimer();
  }
  
  _restartAutoplay() {
    // Only restart if autoPlay is enabled and slider exists
    if (this.autoPlay && this.slider && this.mediaQuery.matches) {
      this._setupAutoplay();
    }
  }

  disconnectedCallback() {
    if (this.slider) {
      this._clearAutoplayTimer();
      this.slider.destroy();
    }
    if (this.mediaQuery) {
      this.mediaQuery.removeListener(this._onMediaQueryChange.bind(this));
    }
    
    this.removeEventListener("announcement-bar:content:open", this._pauseAutoplay.bind(this));
    this.removeEventListener("announcement-bar:content:close", this._restartAutoplay.bind(this));
    this.removeEventListener("mouseenter", this._pauseAutoplay.bind(this));
    this.removeEventListener("mouseleave", this._restartAutoplay.bind(this));
  }
}

window.customElements.define("custom-announcement-bar", CustomAnnouncementBar);

var CustomAnnouncementBarItem = class extends CustomHTMLElement {
connectedCallback() {
    if (this.hasContent) {
      this.contentElement = this.querySelector(".announcement-bar__content");
      this.delegate.on("click", '[data-action="open-content"]', this.openContent.bind(this));
      this.delegate.on("click", '[data-action="close-content"]', this.closeContent.bind(this));
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", this.openContent.bind(this));
        this.addEventListener("shopify:block:deselect", this.closeContent.bind(this));
      }
    }
  }
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get hasContent() {
    return this.hasAttribute("has-content");
  }
  get selected() {
    return !this.hasAttribute("hidden");
  }
  get focusTrap() {
    return this._trapFocus = this._trapFocus || createFocusTrap(this.contentElement.querySelector(".announcement-bar__content-inner"), {
      fallbackFocus: this,
      clickOutsideDeactivates: (event) => !(event.target.tagName === "BUTTON"),
      allowOutsideClick: (event) => event.target.tagName === "BUTTON",
      onDeactivate: this.closeContent.bind(this),
      preventScroll: true
    });
  }
  async select(animate = true) {
    this.removeAttribute("hidden");
    await new Promise((resolve) => {
      this.animate({
        transform: ["translateY(8px)", "translateY(0)"],
        opacity: [0, 1]
      }, {
        duration: animate ? 150 : 0,
        easing: "ease-in-out"
      }).onfinish = resolve;
    });
  }
  async deselect(animate = true) {
    await this.closeContent();
    await new Promise((resolve) => {
      this.animate({
        transform: ["translateY(0)", "translateY(-8px)"],
        opacity: [1, 0]
      }, {
        duration: animate ? 150 : 0,
        easing: "ease-in-out"
      }).onfinish = resolve;
    });
    this.setAttribute("hidden", "");
  }
  async openContent() {
    if (this.hasContent) {
      this.contentElement.addEventListener("transitionend", () => this.focusTrap.activate(), { once: true });
      this.contentElement.removeAttribute("hidden");
      document.documentElement.classList.add("lock-all");
      this.dispatchEvent(new CustomEvent("announcement-bar:content:open", { bubbles: true }));
    }
  }
  async closeContent() {
    if (!this.hasContent || this.contentElement.hasAttribute("hidden")) {
      return Promise.resolve();
    }
    await new Promise((resolve) => {
      this.contentElement.addEventListener("transitionend", () => resolve(), { once: true });
      this.contentElement.setAttribute("hidden", "");
      this.focusTrap.deactivate();
      document.documentElement.classList.remove("lock-all");
      this.dispatchEvent(new CustomEvent("announcement-bar:content:close", { bubbles: true }));
    });
  }
}

// Fix: Klaviyo/cookie-consent popups sometimes leave the body scroll-locked
// after they close, which silently breaks in-page anchor links (clicks do
// nothing because scrolling itself is disabled). Force-clear known lock
// classes right before following an anchor link.
document.addEventListener('click', function (event) {
  const link = event.target.closest('a[href*="#"]');
  if (!link) return;
  document.body.classList.remove('cc-scrolling-disabled', 'klaviyo-prevent-body-scrolling');
  document.documentElement.style.removeProperty('overflow');
  document.body.style.removeProperty('overflow');
}, true);

window.customElements.define("custom-announcement-bar-item", CustomAnnouncementBarItem);